<template>
    <button v-if="as === 'button'" class="color-canvas-button">
        <i class="cvico-icon-canvas icon" :style="{color}"></i>
        <span class="label">
                Edit Your Canvas
        </span>
    </button>
    <inertia-link v-else :href="href" class="color-canvas-button">
        <i class="cvico-icon-canvas icon" :style="{color}"></i>
        <span class="label">
                Edit Your Canvas
            </span>
    </inertia-link>
</template>

<script>
import utils from "@/mixins/utils";
export default {
    name: "ColorCanvasButton",
    components: {},

    mixins: [utils],

    props: {
        as: {
            type: String,
            default: 'button',
        },
        color: {
            type: String,
            default: '#000',
        },
        href: {
            type: String,
            default: null,
        }
    }
}
</script>

<style lang="scss" scoped>
.color-canvas-button{
    display: flex;
    width: fit-content;
    margin-right: auto;
    align-items: center;
    border-radius: .3rem;
    padding: .6rem 1rem .4rem .6rem;
    border: none;
    box-shadow: rgba(black, .1) 0 0 1px;
    line-height: 1;
    background: $light;
    transition: background .3s, box-shadow .3s;
    text-decoration: none;
    @media (max-width: 450px) {
        margin-left: auto;
    }

    &:not(:hover){
        .icon{
            color: darken($light, 25%) !important;
        }
    }

    &:hover{
        box-shadow: rgba(black, .1) 0 3px 5px;
        text-decoration: none;
    }
}

.icon{
    font-size: 2rem;
    margin-right: .6rem;
    transition: color .3s;
}
</style>
